import { useRef, forwardRef } from 'react';
import Lottie, { Options } from 'react-lottie';

interface LottieDivProps {
  json: string,
  imgFolder?: string,
  segment?: [number, number],
  speed?: number,
  defaultOptions?: Omit<Options, 'animationData'>,
}

export function requireAnimationData(jsonName: string, imgFolderName: string) {
  let animationData = require(`../../assets/${jsonName}.json`)
  animationData.assets = animationData.assets.map((a: any) => ({ ...a, u: `${process.env.PUBLIC_URL}/assets/${imgFolderName}/` }));
  return animationData;
}

export default forwardRef((props: LottieDivProps) => {
  const { json, imgFolder, segment } = props;
  const lottieDiv = useRef(null)
  const animationData = requireAnimationData(json, imgFolder ?? json);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    },
    ...props.defaultOptions
  }

  // if (segment && null !== lottieDiv) {
  //   console.log('segment null', lottieDiv);
  //   setTimeout(() => {
  //     console.log('segment', segment, lottieDiv);
  //     // @ts-ignore
  //     (lottieDiv.current as LottieDiv).anim.playSegments(segment, true);
  //   }, 300);
  // }

  return (<Lottie options={defaultOptions} speed={props.speed} ref={(l: any) => {
    if (null !== l) {
      lottieDiv.current = l;
      // console.log('lottie speed', props.speed, lottieDiv.current);
      if (segment) {
        (lottieDiv.current as any).anim.playSegments(segment, true);
      }
      if (props.speed) {
        (lottieDiv.current as any).anim.setSpeed(props.speed);
      }
    }
  }} />);
})
